import { io } from "socket.io-client";
import CONFIG from "../config/config";

let socket = null;

export const getSocket = () => {
  if (!socket) {
    socket = io(CONFIG.BASE_URL, {
      transports: ["websocket", "polling"],
      autoConnect: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
    });

    socket.on("connect", () => {
      console.log("[Socket] Connected:", socket.id);
    });

    socket.on("connect_error", (err) => {
      console.error("[Socket] Connection error:", err.message);
    });

    socket.on("disconnect", (reason) => {
      console.warn("[Socket] Disconnected:", reason);
    });
  }
  return socket;
};

export const joinPortalUserRoom = (userId) => {
  if (!userId) return;
  getSocket().emit("JOIN_PORTAL_USER_ROOM", String(userId));
};

export const subscribeToRobot = (serialID) => {
  if (!serialID) return;
  getSocket().emit("subscribe-robot", serialID);
};

export const unsubscribeFromRobot = (serialID) => {
  if (!serialID) return;
  getSocket().emit("unsubscribe-robot", serialID);
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
